export default __webpack_public_path__ + "media/components/AdEdit/images/vk-promo-logo-8e5874edcfaa1ce56f0f12a94bf3b2fe.png";